import './App.css';
import React from 'react';
import Bills from './Pages/Bills/Bills';
import Quotations from './Pages/Quotations/Quotations';
import { Route, Routes } from 'react-router-dom';
import Login from './Pages/Login/Login';
import DemoBill from './Pages/Bills/DemoBill';
import MeasureSheet from './Pages/MeasureSheet/MeasureSheet';
import CreateBill from './Pages/Bills/CreateBill';
import CreateDemoBill from './Pages/Bills/CreateDemoBill';
import CreateMeasureSheet from './Pages/MeasureSheet/CreateMeasureSheet';
import CreateQuotation from './Pages/Quotations/CreateQuotation';
import TermsAndConditions from './Pages/Quotations/TermsAndConditions';
import Clients from './Pages/Clients/Clients';
import CreateClient from './Pages/Clients/CreateClient';
import LedgerClients from './Pages/Ledger/LedgerClients';
import LedgerDetails from './Pages/Ledger/LedgerDetails';
import PageLayout from './components/PageLayout/PageLayout';
import Home from './Pages/Home/Home';
import Admin from './Pages/Settings/Admin';
import Financials from './Pages/Financials/Financials';
import ClientReports from './Pages/Financials/ClientReports';
import IncomeList from './Pages/Financials/IncomeList';
import CreateIncome from './Pages/Financials/CreateIncome';
import ExpenseList from './Pages/Financials/ExpenseList';
import CreateExpense from './Pages/Financials/CreateExpense';
import PurchaseList from './Pages/Financials/PurchaseList';
import CreatePurchase from './Pages/Financials/CreatePurchase';
import Companies from './Pages/Settings/Companies';
import CreateCompany from './Pages/Settings/CreateCompany';
import Projects from './Pages/Settings/Projects';
import CreateProject from './Pages/Settings/CreateProject';
import Vendors from './Pages/Settings/Vendors';
import CreateVendor from './Pages/Settings/CreateVendor';
import VendorTypes from './Pages/Settings/VendorTypes';
import CreateVendorType from './Pages/Settings/CreateVendorType';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route element={<PageLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/bills" element={<Bills />} />
          <Route path="/demoBills" element={<DemoBill />} />
          <Route path="/measureSheet" element={<MeasureSheet />} />
          <Route path="/quotations" element={<Quotations />} />
          <Route path="/createBill" element={<CreateBill />} />
          <Route path="/createBill/:billId" element={<CreateBill />} />
          <Route path="/createDemoBill" element={<CreateDemoBill />} />
          <Route path="/createDemoBill/:billId" element={<CreateDemoBill />} />
          <Route path="/createMeasureSheet" element={<CreateMeasureSheet />} />
          <Route path="/createMeasureSheet/:sheetId" element={<CreateMeasureSheet />} />
          <Route path="/createQuotations" element={<CreateQuotation />} />
          <Route path="/createQuotations/:quotationId" element={<CreateQuotation />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/createClient" element={<CreateClient />} />
          <Route path="/createClient/:clientId" element={<CreateClient />} />
          <Route path="/ledgerClients" element={<LedgerClients />} />
          <Route path="/ledgerDetails/:clientId" element={<LedgerDetails />} />
          <Route path="/financials" element={<Financials />} />
          <Route path="/financials/client-reports" element={<ClientReports />} />
          <Route path="/financials/income" element={<IncomeList />} />
          <Route path="/createIncome" element={<CreateIncome />} />
          <Route path="/createIncome/:incomeId" element={<CreateIncome />} />
          <Route path="/financials/expense" element={<ExpenseList />} />
          <Route path="/createExpense" element={<CreateExpense />} />
          <Route path="/createExpense/:expenseId" element={<CreateExpense />} />
          <Route path="/financials/purchase" element={<PurchaseList />} />
          <Route path="/createPurchase" element={<CreatePurchase />} />
          <Route path="/createPurchase/:purchaseId" element={<CreatePurchase />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/companies" element={<Companies />} />
          <Route path="/createCompany" element={<CreateCompany />} />
          <Route path="/createCompany/:companyId" element={<CreateCompany />} />
          <Route path="/admin/projects" element={<Projects />} />
          <Route path="/createProject" element={<CreateProject />} />
          <Route path="/createProject/:projectId" element={<CreateProject />} />
          <Route path="/admin/vendors" element={<Vendors />} />
          <Route path="/createVendor" element={<CreateVendor />} />
          <Route path="/createVendor/:vendorId" element={<CreateVendor />} />
          <Route path="/admin/vendor-types" element={<VendorTypes />} />
          <Route path="/createVendorType" element={<CreateVendorType />} />
          <Route path="/createVendorType/:vendorTypeId" element={<CreateVendorType />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
